import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    let observer;
    let timer;
    const stopWaiting = () => {
      observer?.disconnect();
      clearTimeout(timer);
    };
    const scroll = () => {
      stopWaiting();
      const targetHash = window.location.hash;
      if (!targetHash) {
        window.scrollTo(0, 0);
        return;
      }
      const findTarget = () => {
        const target = document.getElementById(targetHash.slice(1));
        if (!target) return false;
        target.scrollIntoView({ behavior: 'smooth' });
        stopWaiting();
        return true;
      };
      if (findTarget()) return;
      observer = new MutationObserver(findTarget);
      observer.observe(document.getElementById('root'), { childList: true, subtree: true });
      timer = setTimeout(stopWaiting, 10000);
    };
    scroll();
    window.addEventListener('hashchange', scroll);
    return () => {
      stopWaiting();
      window.removeEventListener('hashchange', scroll);
    };
  }, [pathname, hash]);

  return null;
}